exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.el-step__description{\r\n  padding-right:0 !important\n}\r\n/*.el-card__body, .el-main{*/\r\n/*  padding: 20px 10px 20px 0;*/\r\n/*}*/\r\n", "", {"version":3,"sources":["C:/Users/Administrator/Documents/hbt-ielts-client-pc-web/src/components/mycenter_studyabroad/component/tab_sixteen.vue"],"names":[],"mappings":";AACA;EACE,0BAA0B;CAC3B;AACD,6BAA6B;AAC7B,gCAAgC;AAChC,KAAK","file":"tab_sixteen.vue","sourcesContent":["\n.el-step__description{\r\n  padding-right:0 !important\n}\r\n/*.el-card__body, .el-main{*/\r\n/*  padding: 20px 10px 20px 0;*/\r\n/*}*/\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9d1f59d2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mycenter_studyabroad/component/tab_sixteen.vue
// module id = H+sT
// module chunks = 1